import SuccessModal from './success-modal';

export default SuccessModal;
